import { useEffect } from 'react'
import { useTravelSearchContext } from '../context/TravelSearchProvider'
import { isMultipleVehclesSupportedWithRoute, isMultipleVehclesSupportedWithVehicleType } from '../Utils/vehicles'
import { isPetsOnlyAllowedInVehicle } from '../Utils/passengers'

export const useSyncTravelSearchSettings = () => {
  const { state, dispatch } = useTravelSearchContext()

  const routeCode = state.selectedRoute?.routeCode
  const vehicleCode = state.selectedVehicle?.code

  useEffect(() => {
    if (!routeCode || !vehicleCode) return

    const multiVehiclesWithRoute = isMultipleVehclesSupportedWithRoute(routeCode)
    const multiVehiclesWithVehicle = isMultipleVehclesSupportedWithVehicleType(vehicleCode)
    const shouldSupportMultipleVehicles = multiVehiclesWithRoute && multiVehiclesWithVehicle

    if (state.multipleVehiclesSupported !== shouldSupportMultipleVehicles) {
      dispatch({ type: 'SET_MULTIPLE_VEHICLES_SUPPORTED', supported: shouldSupportMultipleVehicles })
    }

    if (!shouldSupportMultipleVehicles && state.multipleVehiclesChecked) {
      dispatch({ type: 'SET_MULTIPLE_VEHICLES_CHECKED', checked: false })
    }

    const petsOnlyAllowed = isPetsOnlyAllowedInVehicle(routeCode)
    dispatch({ type: 'SET_PETS_ONLY_ALLOWED_IN_VEHICLE', allowed: petsOnlyAllowed })
  }, [
    routeCode,
    vehicleCode,
    state.routesApiData,
    state.vehicleApiLoading,
    state.multipleVehiclesChecked,
    state.multipleVehiclesSupported,
    dispatch,
  ])

  useEffect(() => {
    const returnRequired = state.selectedRoute?.returnRequired ?? state.routesApiData?.categories?.[0]?.routes?.[0]?.returnRequired ?? false

    if (returnRequired !== state.disableOneWay) {
      dispatch({ type: 'SET_DISABLE_ONE_WAY', disabled: returnRequired })
    }
  }, [state.selectedRoute?.returnRequired, state.routesApiData?.categories?.[0]?.routes?.[0]?.returnRequired, state.disableOneWay])
}
